var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiddleLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 946,
    viewBox: "0 0 1440 946",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2317_2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10 956.5L196.1 754.554C271.305 680.865 369.992 635.916 474.948 627.549L544.106 622.035C671.235 611.899 781.758 530.882 829.681 412.696L833.862 402.387C882.909 281.43 1000.4 202.291 1130.92 202.291C1240.85 202.291 1343.12 145.958 1401.86 53.0398L1433.5 3",
    stroke: "url(#paint0_linear_2317_2)",
    strokeWidth: 11
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 995.5L224.1 793.554C299.305 719.865 397.992 674.916 502.948 666.549L572.106 661.035C699.235 650.899 809.758 569.882 857.681 451.696L861.862 441.387C910.909 320.43 1028.4 241.291 1158.92 241.291C1268.85 241.291 1371.12 184.958 1429.86 92.0398L1461.5 42",
    stroke: "url(#paint1_linear_2317_2)",
    strokeWidth: 11
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 1038.5L258.1 836.554C333.305 762.865 431.992 717.916 536.948 709.549L606.106 704.035C733.235 693.899 843.758 612.882 891.681 494.696L895.862 484.387C944.909 363.43 1062.4 284.291 1192.92 284.291C1302.85 284.291 1405.12 227.958 1463.86 135.04L1495.5 85",
    stroke: "url(#paint2_linear_2317_2)",
    strokeWidth: 11
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2317_2",
    x1: 241.5,
    y1: -30.5,
    x2: 1188.5,
    y2: 983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656C73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2317_2",
    x1: 269.5,
    y1: 8.50003,
    x2: 1216.5,
    y2: 1022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656C73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2317_2",
    x1: 303.5,
    y1: 51.5,
    x2: 1250.5,
    y2: 1065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656C73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2317_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 946,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleLines);
export default __webpack_public_path__ + "static/media/middle-lines.6559f00a50d9f30d2bbb4a355d1b49f7.svg";
export { ForwardRef as ReactComponent };